// ACCEL NOTE: PoC for connected components in workspaces
import React from "react";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import usePDPContentfulData from "../../common/lib/getPDPContentfulData";

const selectPid = createSelector(
  [(state) => state?.productDetailPage?.current?.productSummary?.productId],
  (productId) => {
    return productId;
  }
);

const pdpContefulSelector = createSelector(
  [(state) => state?.pdpContentful, selectPid],
  (pdpContentful, pid) => {
    return pdpContentful?.[pid];
  }
);

const ConnectedFranchiseComparison = () => {
  const pdpContentfulData = useSelector(pdpContefulSelector);
  const pid = useSelector(selectPid);
  const contentful = usePDPContentfulData(pid);
  console.log("ConnectedFranchiseComparison", {
    pdpContentfulData,
    contentful,
    pid
  });

  return (
    <div>
      <h1>Connected Franchise Comparison</h1>
      <pre>{JSON.stringify(pdpContentfulData || "no data", null, 2)}</pre>
    </div>
  );
};

export default ConnectedFranchiseComparison;
